import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  ExpansionPanelComponent,
  ExpansionPanelContentComponent,
} from './expansion-panel.component';
import { ExpansionStepperComponent } from './expansion-stepper/expansion-stepper.component';
import { ExpansionPanelHeaderComponent } from './expansion-panel-header.component';
import { ExpansionStepComponent } from './expansion-stepper/expansion-step.component';

@NgModule({
  declarations: [
    ExpansionPanelComponent,
    ExpansionPanelHeaderComponent,
    ExpansionPanelContentComponent,
    ExpansionStepperComponent,
    ExpansionStepComponent,
  ],
  imports: [CommonModule],
  exports: [
    ExpansionPanelComponent,
    ExpansionPanelHeaderComponent,
    ExpansionPanelContentComponent,
    ExpansionStepperComponent,
    ExpansionStepComponent,
  ],
})
export class ExpansionModule {}
